import { render, staticRenderFns } from "./NotificationsCategorySettings.vue?vue&type=template&id=77e24948&scoped=true"
import script from "./NotificationsCategorySettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsCategorySettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsCategorySettings.vue?vue&type=style&index=0&id=77e24948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e24948",
  null
  
)

export default component.exports